import Message from '@acri-tools/react-tools/components/Message/Message';
import Select from '@acri-tools/react-tools/components/Select/Select';
import request from '@acri-tools/react-tools/utils/request';
import React,{Component} from 'react';
import { connect } from 'react-redux';
import CreateRequestComponent from '../../../../components/CreateRequest/CreateRequest';

interface Props{
    // REDUX
    product_types?:any
}
interface State{
    name: string,
    products: Array<any>,

    message: string,
    messageType: string

    loading: boolean

}

const _default = {
    name: '',
    products: []
}

class CreateRequest extends Component<Props, State>{
    
    constructor(props:Props){
        super(props);
        this.state={
            ..._default,

            loading:false,
            message: '',
            messageType: 'info'
        }
    }
    componentDidMount() {
    }
    render(){
        return (
            <>
                <div className="panel panel-big">
                    
                    <h1 className="title-1">Create new request</h1>
                    {/* <div className="subtitle-1">Create a new graph mode for KPI 2</div> */}
                    <br/>
                    <CreateRequestComponent/>
                </div>
            </>
        );
    }

    // onEnter = (e:any) =>{
    //     if(e.keyCode === 13){
    //         this.create();
    //     }
    // }

    // create = async() =>{
    //     if(!this.state.name)
    //         this.setState({ message: `Missing name`, messageType: 'warn' });
    //     // TODO check products
        
    //     this.setState({ loading:true });
    //     try{
    //         let res = await request(`${API_URL}/api/v1/kpi_2_graph_modes`,{
    //             method:'post',
    //             data: { 
    //                 name: this.state.name,
    //                 products: this.state.products
    //             }
    //         })
    //         this.setState({
    //             ..._default,
    //             products:[],
    //             message: res.data.message  ? res.data.message : 'An error has occured.',
    //             messageType: 'success',
    //         });
    //     }
    //     catch(e:any){
    //         axiosErrorHandler( e, { 
    //             functionName: 'add', 
    //             requestName: 'create_kpi_2_graph_mode',
    //         } )
    //         this.setState({
    //             message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
    //             messageType: 'error'
    //         })
    //     }
    //     finally{
    //         this.setState({ loading:false });
    //     }        
    // }
};


export default connect((state:any)=>{
    return {
    }
})(CreateRequest);
